<template>
    <div>
        <div class="tree gdheight mrt10" id="gdtree">
            <el-tree
                    ref="tree"
                    :data="treeData"
                    lazy
                    :load="loadNode"
                    :props="defaultProps"
                    node-key="i_id"
                    @node-click="handleNodeClick"
                    class="trees  video-tree height100"
                    accordion
                    :highlight-current='true'
                    :expand-on-click-node="false">
<!--      -->
<!---->
            </el-tree>
        </div>
    </div>
</template>

<script>
    import * as API from "./../api"
    import {mapActions} from "vuex";

    export default {
        name: "index",
        components: {},
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf'
                },
                expanded:[],
                treeData:[],
                // treeData:[{
                //     label: '111',
                //     leaf:true,
                //     children: [{
                //         label: '112',
                //         children: [{
                //             label: '113',
                //             i_state:2,
                //
                //         }],
                //     },{
                //         label: '122',
                //         children: [{
                //             label: '123',
                //             i_state:2,
                //
                //         }],
                //     }],
                //
                // },
                // {
                //     label: '211',
                //     children: [{
                //         label: '212',
                //         children: [{
                //             label: '213',
                //             children: [{
                //                 label: '2131',
                //                 i_state:2,
                //
                //             }],
                //         }],
                //     },{
                //         label: '222',
                //         children: [{
                //             label: '223',
                //             children: [{
                //                 label: '2231',
                //                 i_state:2,
                //
                //             }],
                //         }],
                //     }],
                //
                // },{
                //     label: '311',
                //     children: [{
                //         label: '312',
                //         children: [{
                //             label: '313',
                //             i_state:2,
                //             children: [{
                //
                //             }],
                //         }],
                //     }],
                //
                // }
                // ],

            }
        },
        mounted() {
// this.getDeptRightTree()
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),

            async getDeptRightTree({value=0,i_state=0},resolve){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,
                    i_pid:value,
                    i_state:i_state,
                };
                let res = await API.getDeptRightTree(param);
                if (res.code == 1) {


                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                value:one.i_id,
                                i_state:one.i_state,
                                i_pid:one.i_pid,
                                i_uid_auth:one.i_uid_auth,
                                vc_ustate_auth:one.vc_ustate_auth,
                                isLeaf: one.haschild==0,
                            };
                            list.push(hash);
                        })
                    }
                    // console.log(list,'tree')
                    // if (pid!=0){
                        return resolve(list);
                    // }else {
                    //     this.treeData=list
                    // }

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            handleNodeClick(val){
                // console.log(val,'treeData')
                this.$emit('showData',val)


            },
            loadNode(node, resolve) {
                // console.log(this.treeData,'treeData');
                let _this=this;
                if (node.level === 0) {
                    let val={
                        value:0,
                        i_level:1,
                        i_state:0,

                    }
                    setTimeout(() => {
                        _this.getDeptRightTree(val,resolve);
                    }, 100)
                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.getDeptRightTree(node.data,resolve);
                }
            },
            // loadNode(node, resolve) {
            //     if (node.level === 0) {
            //         return resolve([{ vc_name: '全部' }]);
            //     }
            //     if (node.level > 2) return resolve([]);
            //     let i=0
            //     setTimeout(() => {
            //         i++
            //         const data =this.treeData[i].children;
            //         resolve(data);
            //     }, 500);
            // }
        }
    }
</script>

<style lang="scss" scoped>
/deep/.el-tree-node__label{
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>